// extracted by mini-css-extract-plugin
module.exports = {"container":"_31ffc2c","summaryWrapper":"_553d07f","summaryTitle":"_afdb1c5","summaryContent":"_fe1eef4"};